

































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import * as types from "../../store/types";

export default Vue.extend({
  name: "ApplicationStep1",

  props: {},

  data: () => {
    const checks = [
      {
        question: "The business is located in Greene County, Missouri. ",
        shouldBeChecked: true,
        requirement:
          "The business must be located in Greene County, Missouri. Funds are only available for businesses serving residents of Greene County, Missouri.",
      },
      {
        question:
          "The business is a for-profit business that employs (the equivalent of) 100 or fewer full-time employees, including the owner(s).",
        shouldBeChecked: true,
        requirement:
          "The business must be a for-profit business that employs (the equivalent of) 100 or fewer full-time employees, including the owner(s).",
      },
      {
        question:
          "The business is not a family farm or a home-based business, OR if the business is a family farm or a home-based business, the business is 40% of your income as reported on your taxes.",
        shouldBeChecked: true,
        requirement:
          "If the business is a family farm or a home-based business, the business must be 40% of your income as reported on your taxes.",
      },
      {
        question:
          "Immigrant workers are not employed by this business, OR any immigrant workers that are employed by this business are properly documented and legal.",
        shouldBeChecked: true,
        requirement:
          "The business must not employ undocumented immigrant workers.",
      },
      {
        id: "everify",
        question:
          "The business does not have W-2 employees, OR if the business has W-2 employees, it is registered with E-Verify.",
        shouldBeChecked: true,
        requirement:
          "If you have any w-2 employees, you must be registered with E-Verify.",
      },
      {
        question:
          "The business has existed in Greene County, Missouri since March 1st, 2020. This date signifies the beginning of the COVID-19 Pandemic and thus the beginning of our funding.",
        shouldBeChecked: true,
        requirement:
          "The business must have existed in Greene County, Missouri since March 1st, 2020. This date signifies the beginning of the COVID-19 Pandemic and thus the beginning of our funding.",
      },
      {
        question:
          "The business can demonstrate the existence of negative impacts incurred as a result of the COVID-19 public health emergency since March 1st, 2020.",
        shouldBeChecked: true,
        requirement:
          "The business must demonstrate the existence of negative impacts incurred as a result of the COVID-19 public health emergency since March 1st, 2020.",
      },
      {
        question:
          "The business is not suspended, debarred, proposed for debarment, declared ineligible, presently involved in bankruptcy or voluntarily excused from participation in this transaction.",
        shouldBeChecked: true,
        requirement:
          "The business must not be suspended, debarred, proposed for debarment, declared ineligible, presently involved in bankruptcy or voluntarily excused from participation in this transaction.",
      },
      {
        question:
          "The business, all owners, and all businesses owned or controlled by any owners have not obtained a direct or guaranteed loan from a federal or state agency that is currently delinquent or has defaulted in the last 7 years.",
        shouldBeChecked: true,
        requirement:
          "The business, all owners, and all businesses owned or controlled by any owners must not have obtained a direct or guaranteed loan from a federal or state agency that is currently delinquent or has defaulted in the last 7 years.",
      },
    ];
    return {
      showIneligibleDialog: false,
      checks,
      checkValues: checks.map(() => false),
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      const checkedAll = this.checkValues.every((checked) => checked);
      this.$emit("update-validity", 0, checkedAll);
      if (checkedAll) {
        // we're valid, call save then continue on
        this.saveStep({
          newCurStepNum: 1, // next step
          formFields: {
            eligible: true,
          },
        });
        this.$emit("next-step");
      } else {
        this.showIneligibleDialog = true;
      }
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),
    disqualifyingReasons(): string[] {
      return this.checks
        .filter((check, i) => check.shouldBeChecked != this.checkValues[i])
        .map((check) => check.requirement);
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        this.$emit("update-validity", 0, this.allFormValues.eligible);
        if (this.allFormValues.eligible)
          this.checkValues = this.checks.map(() => true);
      },
    },
  },
});
